export class CrosshairPoint {
  argument: number | null;
  value: number | null;

  constructor() {
    this.argument = null;
    this.value = null;
  }
}
